export default [
    {
        path: '/(uk/|ru/)?/transactions/index',
        name: 'Transactions',
        component: () => import('../views/transactions/Transactions'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Ручные транзакции'
        },
    }, {
        path: '/(uk/|ru/)?/transactions/mass',
        name: 'Mass',
        component: () => import('../views/transactions/Mass'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Массовые транзакции'
        },
    }, {
        path: '/(uk/|ru/)?/transactions/mass/detail',
        redirect: '/(uk/|ru/)?/transactions/mass/detail/info',
        name: 'FormMass',
        component: () => import('../views/transactions/form/FormMass'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
        },
        children: [
            {
                path: '/(uk/|ru/)?/transactions/mass/detail/info',
                name: 'MainInfo',
                component: () => import('../views/transactions/form/MainInfo'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Новая массовая транзакция'
                },
            }, {
                path: '/(uk/|ru/)?/transactions/mass/detail/import',
                name: 'Import',
                component: () => import('../views/transactions/form/Import'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Новая массовая транзакция'
                },
            }, {
                path: '/(uk/|ru/)?/transactions/mass/detail/drivers',
                name: 'Drivers',
                component: () => import('../views/transactions/form/Drivers'),
                query: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Редактирование массовой транзакции'
                },
            }
        ]
    }, {
        path: '',
        component: () => import('../views/transactions/Statements'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-transaction',
            title: 'Ведомость',
            altNavSubMenuActive:'/transactions/statements',
        },
        children: [
            {
                path: '/(uk/|ru/)?/transactions/statements',
                name: 'StatementsCommon',
                component: () => import('../views/transactions/tables/Common'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Ведомость'
                },
            }, {
                path: '/(uk/|ru/)?/transactions/statements/parks',
                name: 'StatementsParks',
                component: () => import('../views/transactions/tables/Parks'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Ведомость'
                },
            }, {
                path: '/(uk/|ru/)?/transactions/income',
                name: 'Income',
                component: () => import('../views/transactions/Income'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Отчеты'
                },
            }, {
                path: '/(uk/|ru/)?/transactions/drivers',
                name: 'StatementsDrivers',
                component: () => import('../views/transactions/tables/Drivers'),
                query: true,
                props: true,
                meta: {
                    requiresAuth: true,
                    activeSideIcon:'#icon-transaction',
                    title: 'Ведомость'
                },
            },
        ]
    }, {
        path: '/(uk/|ru/)?/transactions/bonus',
        name: 'TransactionsBonus',
        component: () => import('../views/transactions/bonus'),
        query: true,
        meta: {
            requiresAuth: true,
            activeSideIcon:'#icon-discount',
            title: 'Список бонусов'
        }
    },
]
